<template>
  <div
    data-cy="waitingInitialDataMessage"
    :class="['waiting-connection', className]"
  >
    <span>{{ deviceConnectedText }}</span>
    <span>{{ waitingInitialDataText }}</span>
  </div>
</template>

<script>
export default {
  name: 'WaitingInitialData',
  props: {
    className: {
      type: String,
      default: '',
    },
  },
  computed: {
    deviceConnectedText() {
      return this.$t('widget.currentReadings.deviceConnected') || ''
    },
    waitingInitialDataText() {
      return this.$t('widget.currentReadings.waitingData') || ''
    },
  },
}
</script>

<style>
.waiting-connection {
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  z-index: 2000;
  color: black !important;
}
.waiting-connection > span:first-child {
  font-weight: bold;
  margin-bottom: 4px;
}

.smart-bridge-card  {
  width: 92%;
  height: 140px;
  top: 110px;
  left: 0;
  margin: 4%;
}

.standard-card  {
  width: 92%;
  height: 59%;
  top: 32%;
  left: 0;
  margin: 4%;
}
</style>
